export interface TemplateColorPalette {
  strokeColor: string;
  fillColor: string;
  highlightColor: string;
}

// Predefined color palette for new treatment plan templates (cycles on creation).
export const TEMPLATE_COLOR_PALETTE: TemplateColorPalette[] = [
  { strokeColor: '#89A6FB', fillColor: '#89A6FB33', highlightColor: '#89A6FB' },
  { strokeColor: '#D48C72', fillColor: '#D48C7233', highlightColor: '#D48C72' },
  { strokeColor: '#7871AA', fillColor: '#9B82C433', highlightColor: '#7871AA' },
  { strokeColor: '#97BA56', fillColor: '#97BA5633', highlightColor: '#97BA56' },
  { strokeColor: '#70B5C6', fillColor: '#70B5C633', highlightColor: '#70B5C6' },
  { strokeColor: '#F498CF', fillColor: '#D980B633', highlightColor: '#F498CF' }
];
